import { render } from "./PdfSigner.vue?vue&type=template&id=46434dea&scoped=true"
import script from "./PdfSigner.vue?vue&type=script&lang=js"
export * from "./PdfSigner.vue?vue&type=script&lang=js"

import "./PdfSigner.vue?vue&type=style&index=0&id=46434dea&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46434dea"]])

export default __exports__